/**
 * @file shareConfig.js
 * @desc 重新定义地图客户端分享到微信或微博的文案
 * @author zhuqijia
 */
import {initShare, makeTextShareData, makePicShareData, openShare, customShare} from '@baidu/map-fe-utils';

// 初始化分享配置
const url = location.origin + location.pathname;
const base = 'baidumap://map/cost_share?popRoot=no&transparentWeb=0&navigationStatus=2&hiddenBackBtn=0&hiddenTitle=1&url=';
const detailNaUrl = base + encodeURIComponent(url + '?fr=weixin');

// 基础配置
const baseConf = {
    url: url,
    wxTitle: '全景探险家招募令',
    wxText: '看实景 猜城市 赢无人机大礼！开启探险>>',
    wxFriendText: '看实景 猜城市 赢无人机大礼！开启探险>>',
    weiboText: '看实景 猜城市 赢无人机大礼！开启探险>>',
    wxPic: 'https://cjh-amis.cdn.bcebos.com/2021-11/1637132966707/300_300%20%E6%8B%B7%E8%B4%9D.png',
    weiboPic: 'https://cjh-amis.cdn.bcebos.com/2021-11/1637132966044/400_300.png',
    wxBigPic: 'https://cjh-amis.cdn.bcebos.com/2021-11/1637132966044/400_300.png',
    wxType: 0, // 0：普通，1：小程序
    wxMnpType: 0, // 0正式版，1为小程序预览版 2为小程序测试版本
    wxMnpUrl: '/pages/index/share/main', // 0正式版，1为小程序预览版 2为小程序测试版本
    wxMnpPath: '/pages/index/share/main?params=',
    wxMnpUsername: 'gh_6955c95d46ce',
    wxMnpParams: {
        title: '全景探险家招募令',
        text: '看实景 猜城市 赢无人机大礼！开启探险>>',
        detailNaUrl: detailNaUrl
    }
};

// 3.0基础配置
const baseConf3 = Object.assign({}, baseConf, {
    wxPic: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/wxShare.png',
    weiboPic: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/wbShare.png',
    wxBigPic: 'https://map-yunying.cdn.bcebos.com/%20map-yunying/pano-game/v3/share/wbShare.png'
});

// 分享页问题分享配置
let questionShareConf = Object.assign({}, baseConf, {
    wxTitle: '不愧是我！我在全景探险中1s就认出了这个地方~',
    wxText: '看看这是哪>>',
    wxFriendText: '不愧是我！我在全景探险中1s就认出了这个地方 看看这是哪>>  ',
    weiboText: '不愧是我！我在全景探险中1s就认出了这个地方 看看这是哪>>  ',
    wxPic: 'https://cjh-amis.cdn.bcebos.com/2021-11/1637132966707/300_300%20%E6%8B%B7%E8%B4%9D.png',
    weiboPic: 'https://cjh-amis.cdn.bcebos.com/2021-11/1637132966044/400_300.png'
});

// 组装最终版本首页分享信息
let shareConf = Object.assign(baseConf, baseConf3); ;

/**
 * 初始化首页页面分享参数
 *
 * @param {Object} shareConfig - 分享页面参数
 */
export const initMainShare = (shareConfig = {}) => {
    shareConf = Object.assign(shareConf, shareConfig);
    initShare(makeTextShareData(shareConf, true));
};

/**
 * 普通分享
 */
export const mainShare = (shareConfig = {}) => {
    shareConf = Object.assign(shareConf, shareConfig);
    initShare(makeTextShareData(shareConf, true));
    openShare();
};

/**
 * 初始化问题分享分享参数
 */
export const initQuestionShare = (shareConfig = {}) => {
    questionShareConf = Object.assign(questionShareConf, shareConfig);
    initShare(makeTextShareData(questionShareConf, true));
};

// 问题分享
export const questionShare = (shareConfig = {}) => {
    customShare(makeTextShareData(Object.assign(questionShareConf, shareConfig), true));
};

/**
 * 大图分享
 *
 * @param {String} imgUrl - 图片地址
 */
export const posterShare = imgUrl => {
    customShare(makePicShareData(imgUrl));
};
